import React, { useEffect } from 'react';
import { Collapse, Col, Divider } from 'antd';
import { SettingsRouteProps } from './Settings';
import { useSelector } from 'react-redux';
import { getSettingsState } from '../../store/settings/selector';
import { useTranslation } from 'react-i18next';

export const Faq: React.FC<SettingsRouteProps> = ({ setHeaderTitle }) => {
  const { settings } = useSelector(getSettingsState);
  const { faqs } = settings;
  const { t } = useTranslation();

  const setHeader: React.EffectCallback = () => {
    if (setHeaderTitle) setHeaderTitle('FAQ');
  };

  const panelKey = (panelProps: any) => {
    return <div className="expand-icon">{panelProps.panelKey}</div>;
  };
  useEffect(setHeader, [setHeaderTitle]);
  return (
    <Col className="faqs-block margin-top">
      <Collapse accordion expandIcon={panelKey}>
        {faqs.map((faq, i) => {
          return (
            <Collapse.Panel header={t(faq.title)} key={i + 1}>
              <div
                dangerouslySetInnerHTML={{
                  __html: t(faq.description),
                }}
              />
              <Divider />
            </Collapse.Panel>
          );
        })}
      </Collapse>
    </Col>
  );
};
